import React, { useContext, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Tags } from 'lucide-react';
import { axios, auth, mbUrl, MbContext, muted, runCall, toast } from './mbApi';

const NONE = '__none__';

export const MetadataEditor = ({ ibId, c, canWrite, reload }) => {
  const { analyst } = useContext(MbContext);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({});
  const [busy, setBusy] = useState(false);
  const start = () => { setF({ angle: c.angle || '', angle_tag: c.angle_tag || '', hook: c.hook || '', format: c.format || '', visual_type: c.visual_type || '' }); setOpen(true); };
  const save = () => runCall(setBusy, async () => {
    const r = await axios.put(mbUrl(ibId, `/creatives/${c.id}/metadata`), f, auth());
    if (r.data.review_reset) toast.warning('Hook/angle/format berubah — kelulusan versi ni dibatalkan, perlu review semula');
    setOpen(false);
    reload();
  }, 'Metadata disimpan');
  const material = ['lulus', 'perlu_ubah'].includes(c.review_status) && ['angle', 'hook', 'format'].some((k) => (f[k] || '') !== (c[k] || ''));
  const missing = ['angle', 'angle_tag', 'hook', 'format', 'visual_type'].filter((k) => !c[k]).length;
  if (!open) {
    return (
      <span className={`text-[11px] ${muted} flex items-center gap-1.5`} data-testid={`mb-meta-${c.id}`}>
        <Tags size={11} /> {c.angle_tag ? <span className="px-1.5 rounded bg-white/10">{c.angle_tag}</span> : 'Tag angle belum diset'}
        {c.visual_type && <span className="px-1.5 rounded bg-white/10">{c.visual_type}</span>}
        {missing > 0 && <span className="text-amber-400">{missing} metadata belum lengkap</span>}
        {canWrite && <button className="underline" onClick={start} data-testid={`mb-meta-edit-${c.id}`}>Metadata</button>}
      </span>
    );
  }
  const sel = (k, opts, ph) => (
    <Select value={f[k] || NONE} onValueChange={(v) => setF({ ...f, [k]: v === NONE ? '' : v })}>
      <SelectTrigger className="h-8 text-xs w-56" data-testid={`mb-meta-${k}-${c.id}`}><SelectValue placeholder={ph} /></SelectTrigger>
      <SelectContent><SelectItem value={NONE}>— {ph} —</SelectItem>{opts.map((o) => <SelectItem key={o} value={o}>{o}</SelectItem>)}</SelectContent>
    </Select>
  );
  return (
    <div className="flex flex-wrap gap-1.5 w-full rounded border border-[hsl(var(--border))] p-2" data-testid={`mb-meta-form-${c.id}`}>
      <Input className="h-8 text-xs w-48" placeholder="Angle (motivasi utama)" value={f.angle} onChange={(e) => setF({ ...f, angle: e.target.value })} data-testid={`mb-meta-angle-${c.id}`} />
      {sel('angle_tag', analyst?.angle_tags || [], 'Tag angle standard')}
      <Input className="h-8 text-xs w-64" placeholder="Hook sebenar (ayat pembuka)" value={f.hook} onChange={(e) => setF({ ...f, hook: e.target.value })} data-testid={`mb-meta-hook-${c.id}`} />
      <Input className="h-8 text-xs w-36" placeholder="Format (poster 1:1, video 15s)" value={f.format} onChange={(e) => setF({ ...f, format: e.target.value })} data-testid={`mb-meta-format-${c.id}`} />
      {sel('visual_type', analyst?.visual_types || [], 'Jenis visual')}
      <Button size="sm" className="h-8 text-xs" disabled={busy} onClick={save} data-testid={`mb-meta-save-${c.id}`}>Simpan</Button>
      <Button size="sm" variant="ghost" className="h-8 text-xs" onClick={() => setOpen(false)}>Batal</Button>
      <p className={`w-full text-[10px] ${muted}`}>Angle = motivasi utama · Hook = ayat pembuka · Format = poster/video. Jangan samakan ketiga-tiganya. Tag standard membolehkan sistem kumpul satu keluarga konsep.</p>
      {material && <p className="w-full text-xs text-amber-400" data-testid={`mb-meta-reset-warn-${c.id}`}>Versi ni dah direview. Ubah angle/hook/format akan batalkan keputusan review — Firzan perlu review semula. Tukar tag/jenis visual sahaja tak batalkan.</p>}
    </div>
  );
};
